import React, { useEffect, useState } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import api from '../utils/api';
import { ArrowLeft, ClipboardList, CheckCircle, Plus } from 'lucide-react';

const JobCardList = () => {
  const { soId } = useParams();
  const navigate = useNavigate();
  const [so, setSo] = useState(null);
  const [cards, setCards] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const [orders, jcRes] = await Promise.all([
          api.get('/sales/orders'),
          api.get(`/job-cards/by-sales-order/${soId}`),
        ]);
        setSo((orders.data || []).find(o => o.id === soId));
        setCards(jcRes.data || []);
      } catch (e) { console.error(e); } finally { setLoading(false); }
    })();
  }, [soId]);

  if (loading) return <div style={{ padding: 20 }}>Loading...</div>;
  if (!so) return <div style={{ padding: 20 }}>Sales order not found.<button onClick={() => navigate('/sales-orders')} className="btn btn-secondary" style={{ marginLeft: 12 }}>Back</button></div>;

  const cardByItem = (idx) => cards.find(c => (c.sales_order_item_index ?? 0) === idx);

  return (
    <div data-testid="job-card-list-page" style={{ maxWidth: '1100px', margin: '0 auto', padding: '16px' }}>
      <div className="flex items-center justify-between mb-4">
        <div>
          <button onClick={() => navigate('/sales-orders')} className="btn btn-ghost btn-sm"><ArrowLeft size={14} /> Sales Orders</button>
          <h1 style={{ fontSize: '22px', fontWeight: 700, margin: '6px 0 0' }}>Job Cards for {so.order_number}</h1>
          <div style={{ fontSize: '13px', color: 'var(--text-tertiary)' }}>{so.customer_name} · {(so.items || []).length} line item(s) — one job card per item</div>
        </div>
      </div>

      <div className="card">
        <div className="table-container">
          <table>
            <thead>
              <tr>
                <th>#</th>
                <th>Product Name</th>
                <th>Product Type</th>
                <th className="text-right">Quantity</th>
                <th>Job Card</th>
                <th>BOM</th>
                <th>Production Order</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {(so.items || []).map((it, idx) => {
                const jc = cardByItem(idx);
                return (
                  <tr key={idx} data-testid={`jc-row-${idx}`}>
                    <td className="font-mono">{idx + 1}</td>
                    <td>{it.name || '-'}</td>
                    <td>{it.final_product_type ? <span className="badge badge-info">{it.final_product_type}</span> : '-'}</td>
                    <td className="text-right tabular-nums">{it.quantity}</td>
                    <td>{jc ? <span className="badge badge-success"><CheckCircle size={12} /> #{jc.job_card_no}</span> : <span className="badge badge-warning">Not created</span>}</td>
                    <td>{jc?.bom_id ? <span className="badge badge-success">Saved</span> : <span style={{ color: 'var(--text-tertiary)', fontSize: 12 }}>—</span>}</td>
                    <td>{jc?.production_order_number ? <span className="font-mono text-sm">{jc.production_order_number}</span> : <span style={{ color: 'var(--text-tertiary)', fontSize: 12 }}>—</span>}</td>
                    <td>
                      <Link to={`/sales-orders/job-card/${soId}/${idx}`} className="btn btn-primary btn-sm" data-testid={`open-jc-${idx}`}>
                        {jc ? <><ClipboardList size={14} /> Open</> : <><Plus size={14} /> Create</>}
                      </Link>
                    </td>
                  </tr>
                );
              })}
              {(so.items || []).length === 0 && (
                <tr><td colSpan={8} style={{ textAlign: 'center', padding: '20px', color: 'var(--text-tertiary)' }}>This order has no line items.</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default JobCardList;
